import {

  CORE_LOAD_ALLBUILDING_REQUEST,
  CORE_LOAD_ALLBUILDING_SUCCESS,

  CORE_LOAD_BUILDINGINFO_REQUEST,
  CORE_LOAD_BUILDINGINFO_SUCCESS,

} from '../../../types'

const initialState = []
export default {
  building: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLBUILDING_REQUEST:
        return initialState

      case  CORE_LOAD_ALLBUILDING_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  buildingInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_BUILDINGINFO_REQUEST:
        return initialState

      case  CORE_LOAD_BUILDINGINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/location/building/reducer.js